// extracted by mini-css-extract-plugin
module.exports =  {"container":"_2787e5dfdf--container--_Bh64","title":"_2787e5dfdf--title--y6oYs","wrapper":"_2787e5dfdf--wrapper--t1Yuc","wrapper-mobile":"_2787e5dfdf--wrapper-mobile--xI5FK"};